var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "full-screen-modal",
      attrs: {
        id: "alert-info-modal",
        centered: "",
        "hide-footer": "",
        "hide-header": "",
        "ok-variant": "primary"
      }
    },
    [
      _c("div", [
        _c("div", { staticClass: "col-12 custom-col-12" }, [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              attrs: { id: "container-title-modal-alert-info" }
            },
            [
              _c("i", {
                staticClass:
                  "ph-custom ph-question mr-2 ph-custom-question-alert-info-modal"
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "page-subtitle text-white" }, [
          _vm._v(_vm._s(_vm.$t("alert.info.title")))
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "mt-3 mb-3",
          attrs: { id: "custom-p-modal-alert-info" },
          domProps: { innerHTML: _vm._s(_vm.$t("alert.info.description")) }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ae80d40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ae80d40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/AlertInfoModal.vue
// module id = N7CM
// module chunks = 0